




























import gsap from 'gsap';
import dashjs from 'dashjs';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  private playerShow = true;
  private contentShow = false;
  private page: any;

  private enter(el: HTMLElement, done: any){
    gsap.from(el, .3, {opacity: 0, right: 100, onComplete: () => {
        done();
        this.contentShow = false;
      }
    })
  }

  private leave(el: HTMLElement, done: any){
    gsap.to(el, .3, {opacity: 0, left: 100, onComplete: () => {
        done();
        this.contentShow = true;
      }
    })
  }

  private mounted(){
    this.page = this.$route.query.p;

    if(this.page){
      this.$router.push(''+this.page);
    }
  }
}
